import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TimeZoneReselectService {

  private readonly pendingSubject = new BehaviorSubject<string | null>(null);
  private savedZoneId: string | null = null;

  get pending$(): Observable<string | null> {
    return this.pendingSubject.asObservable();
  }

  requestPreselect(timeZoneId: string): void {
    this.pendingSubject.next(timeZoneId);
  }

  clearPreselect(): void {
    this.pendingSubject.next(null);
  }

  savedZone(currentProfileZoneId: string | null | undefined): string | null {
    if (this.savedZoneId === null && typeof currentProfileZoneId === 'string') {
      this.savedZoneId = currentProfileZoneId;
    }
    return this.savedZoneId;
  }

  recordSaved(timeZoneId: string): void {
    this.savedZoneId = timeZoneId;
  }
}
